<template>
  <div>
    <div class="login-container" v-pageBuried :data-page-buried="bgBuriedText">
      <img class="image" :src="backgroundImage" alt="" />
      <img
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ac7fef8be2ed1e919276f9dc2f7135a6.png"
        alt=""
        class="btn"
        @click="bindRegister"
        v-clickBuried
        :data-click-buried="clickBuriedText"
      />
    </div>
    <van-popup v-model="showLogin" position="bottom">
      <MyLogin
        title="填写您的信息"
        @close="bindLoginClose"
        @login="bindLogin"
        :haveExchange="haveExchange"
      ></MyLogin>
    </van-popup>
  </div>
</template>
<script>
import MyLogin from './components/login.vue'
export default {
  components: {
    MyLogin
  },
  data() {
    return {
      defaultBackgroundImage:
        'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2f5bfc9c1b6bf0b3e1e0179cda8c0041.png',
      showLogin: false,
      backgroundData: null
    }
  },
  computed: {
    backgroundImage() {
      if (this.backgroundData) {
        let sfrom = this.$route.query.sfrom
        let item = this.backgroundData.find((item) => {
          return item.channel == sfrom
        })
        return (item && item.image_url) || this.defaultBackgroundImage
      } else {
        return ''
      }
    },
    haveExchange() {
      return this.$route.query.sfrom == 'SQLX_TAOBO'
    },
    bgBuriedText() {
      return 'BG_' + (this.$route.query.sfrom || '')
    },
    clickBuriedText() {
      return 'CLICK_' + (this.$route.query.sfrom || '')
    }
  },
  created() {
    this.init()
  },
  mounted() {},
  methods: {
    bindRegister() {
      this.showLogin = true
    },
    bindLoginClose() {
      this.showLogin = false
    },
    async init() {
      let res = await this.$http
        .getApp('api/v1/RegisterPushCard/init')
        .catch(() => {
          this.$toast('网络错误')
        })
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.backgroundData = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    },
    bindLogin(options) {
      let sfrom = this.$route.query.sfrom || ''
      let params = {
        phone: options.phone,
        identify_code: options.code,
        areaCode: '86',
        channel: sfrom
      }
      this.$http
        .postApp('api/v1/RegisterPushCard/registerPushWeekCard', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$dialog
              .alert({
                title: '',
                message: res.data.msg || '注册成功'
              })
              .then(() => {
                location.href =
                  'https://btvue.gymcity.com.cn/app-download?sfrom=' + sfrom
              })
          } else {
            this.$toast(res.msg)
          }
        })
        .catch()
    }
  }
}
</script>
<style lang="scss" scoped>
.login-container {
  width: 100%;
  position: relative;
  @include paddingBottom(0px);
  .image {
    width: 100%;
  }
  .btn {
    position: fixed;
    left: 50%;
    transform: translate(-50%, 0%);
    width: 357px;
    @include fixedBottom(0px);
  }
}

.login-content {
  position: fixed;
  width: 100%;
  left: 0;
  bottom: 0;
}
</style>
